var tbEase = /** @class */ (function () {
    function tbEase() {
    }
    //
    // Basic ease functions
    //
    tbEase.easeConstant = function (time, begin, change, duration) {
        return begin;
    };
    tbEase.easeLinear = function (time, begin, change, duration) {
        var val = time / duration;
        return begin + change * val;
    };
    tbEase.easeInPower = function (time, begin, change, duration, power) {
        var val;
        if (power === undefined) {
            power = 3;
        }
        val = Math.pow(time / duration, power);
        return begin + change * val;
    };
    tbEase.easeOutPower = function (time, begin, change, duration, power) {
        var val = tbEase.easeInPower(duration - time, 1, -1, duration, power);
        return begin + change * val;
    };
    tbEase.easeInOutPower = function (time, begin, change, duration, power) {
        var val;
        if (time < duration / 2) {
            val = tbEase.easeInPower(time, 0, 0.5, duration / 2, power);
        }
        else {
            val = tbEase.easeInPower(duration - time, 1, -0.5, duration / 2, power);
        }
        return begin + change * val;
    };
    tbEase.easeOutInPower = function (time, begin, change, duration, power) {
        var val;
        if (time < duration / 2) {
            val = tbEase.easeInPower(duration / 2 - time, 0.5, -0.5, duration / 2, power);
        }
        else {
            val = tbEase.easeInPower(time - duration / 2, 0.5, 0.5, duration / 2, power);
        }
        return begin + change * val;
    };
    tbEase.easeInQuadratic = function (time, begin, change, duration) {
        return tbEase.easeInPower(time, begin, change, duration, 2);
    };
    tbEase.easeOutQuadratic = function (time, begin, change, duration) {
        return tbEase.easeOutPower(time, begin, change, duration, 2);
    };
    tbEase.easeInOutQuadratic = function (time, begin, change, duration) {
        return tbEase.easeInOutPower(time, begin, change, duration, 2);
    };
    tbEase.easeOutInQuadratic = function (time, begin, change, duration) {
        return tbEase.easeOutInPower(time, begin, change, duration, 2);
    };
    tbEase.easeInCubic = function (time, begin, change, duration) {
        return tbEase.easeInPower(time, begin, change, duration, 3);
    };
    tbEase.easeOutCubic = function (time, begin, change, duration) {
        return tbEase.easeOutPower(time, begin, change, duration, 3);
    };
    tbEase.easeInOutCubic = function (time, begin, change, duration) {
        return tbEase.easeInOutPower(time, begin, change, duration, 3);
    };
    tbEase.easeOutInCubic = function (time, begin, change, duration) {
        return tbEase.easeOutInPower(time, begin, change, duration, 3);
    };
    tbEase.easeInQuartic = function (time, begin, change, duration) {
        return tbEase.easeInPower(time, begin, change, duration, 4);
    };
    tbEase.easeOutQuartic = function (time, begin, change, duration) {
        return tbEase.easeOutPower(time, begin, change, duration, 4);
    };
    tbEase.easeInOutQuartic = function (time, begin, change, duration) {
        return tbEase.easeInOutPower(time, begin, change, duration, 4);
    };
    tbEase.easeOutInQuartic = function (time, begin, change, duration) {
        return tbEase.easeOutInPower(time, begin, change, duration, 4);
    };
    tbEase.easeInQuintic = function (time, begin, change, duration) {
        return tbEase.easeInPower(time, begin, change, duration, 5);
    };
    tbEase.easeOutQuintic = function (time, begin, change, duration) {
        return tbEase.easeOutPower(time, begin, change, duration, 5);
    };
    tbEase.easeInOutQuintic = function (time, begin, change, duration) {
        return tbEase.easeInOutPower(time, begin, change, duration, 5);
    };
    tbEase.easeOutInQuintic = function (time, begin, change, duration) {
        return tbEase.easeOutInPower(time, begin, change, duration, 5);
    };
    tbEase.easeInExponential = function (time, begin, change, duration, power) {
        var val, base;
        if (power === undefined) {
            power = 8;
        }
        base = Math.pow(2, -power); // The exponential function will not cover the whole range from 0-1 so we must correct it
        val = (Math.pow(2, power * time / duration - power) - base) / (1 - base);
        return begin + change * val;
    };
    tbEase.easeOutExponential = function (time, begin, change, duration, power) {
        var val = tbEase.easeInExponential(duration - time, 1, -1, duration, power);
        return begin + change * val;
    };
    tbEase.easeInOutExponential = function (time, begin, change, duration, power) {
        var val;
        if (time < duration / 2) {
            val = tbEase.easeInExponential(time, 0, 0.5, duration / 2, power);
        }
        else {
            val = tbEase.easeInExponential(duration - time, 1, -0.5, duration / 2, power);
        }
        return begin + change * val;
    };
    tbEase.easeOutInExponential = function (time, begin, change, duration, power) {
        var val;
        if (time < duration / 2) {
            val = tbEase.easeInExponential(duration / 2 - time, 0.5, -0.5, duration / 2, power);
        }
        else {
            val = tbEase.easeInExponential(time - duration / 2, 0.5, 0.5, duration / 2, power);
        }
        return begin + change * val;
    };
    tbEase.easeInSine = function (time, begin, change, duration) {
        var val = 1 - Math.cos(time / duration * Math.PI / 2);
        return begin + change * val;
    };
    tbEase.easeOutSine = function (time, begin, change, duration) {
        var val = tbEase.easeInSine(duration - time, 1, -1, duration);
        return begin + change * val;
    };
    tbEase.easeInOutSine = function (time, begin, change, duration) {
        var val;
        if (time < duration / 2) {
            val = tbEase.easeInSine(time, 0, 0.5, duration / 2);
        }
        else {
            val = tbEase.easeInSine(duration - time, 1, -0.5, duration / 2);
        }
        return begin + change * val;
    };
    tbEase.easeOutInSine = function (time, begin, change, duration) {
        var val;
        if (time < duration / 2) {
            val = tbEase.easeInSine(duration / 2 - time, 0.5, -0.5, duration / 2);
        }
        else {
            val = tbEase.easeInSine(time - duration / 2, 0.5, 0.5, duration / 2);
        }
        return begin + change * val;
    };
    tbEase.easeInCircular = function (time, begin, change, duration) {
        var val = 1 - Math.sqrt(1 - Math.pow(time / duration, 2));
        return begin + change * val;
    };
    tbEase.easeOutCircular = function (time, begin, change, duration) {
        var val = tbEase.easeInCircular(duration - time, 1, -1, duration);
        return begin + change * val;
    };
    tbEase.easeInOutCircular = function (time, begin, change, duration) {
        var val;
        if (time < duration / 2) {
            val = tbEase.easeInCircular(time, 0, 0.5, duration / 2);
        }
        else {
            val = tbEase.easeInCircular(duration - time, 1, -0.5, duration / 2);
        }
        return begin + change * val;
    };
    tbEase.easeOutInCircular = function (time, begin, change, duration) {
        var val;
        if (time < duration / 2) {
            val = tbEase.easeInCircular(duration / 2 - time, 0.5, -0.5, duration / 2);
        }
        else {
            val = tbEase.easeInCircular(time - duration / 2, 0.5, 0.5, duration / 2);
        }
        return begin + change * val;
    };
    tbEase.easeInElastic = function (time, begin, change, duration, oscillations, stiffness) {
        var val;
        if (oscillations === undefined) {
            oscillations = 3;
        }
        if (stiffness === undefined) {
            stiffness = 8;
        }
        val = Math.sin((1 - time / duration) * 2 * Math.PI * oscillations + Math.PI / 2); // Create the correct sign
        val *= tbEase.easeInExponential(time, 0, 1, duration, stiffness); // Multiply with an exponential ease in
        return begin + change * val;
    };
    tbEase.easeOutElastic = function (time, begin, change, duration, oscillations, stiffness) {
        var val = tbEase.easeInElastic(duration - time, 1, -1, duration, oscillations, stiffness);
        return begin + change * val;
    };
    tbEase.easeInOutElastic = function (time, begin, change, duration, oscillations, stiffness) {
        var val;
        if (time < duration / 2) {
            val = tbEase.easeInElastic(time, 0, 0.5, duration / 2, oscillations, stiffness);
        }
        else {
            val = tbEase.easeInElastic(duration - time, 1, -0.5, duration / 2, oscillations, stiffness);
        }
        return begin + change * val;
    };
    tbEase.easeOutInElastic = function (time, begin, change, duration, oscillations, stiffness) {
        var val;
        if (time < duration / 2) {
            val = tbEase.easeInElastic(duration / 2 - time, 0.5, -0.5, duration / 2, oscillations, stiffness);
        }
        else {
            val = tbEase.easeInElastic(time - duration / 2, 0.5, 0.5, duration / 2, oscillations, stiffness);
        }
        return begin + change * val;
    };
    tbEase.easeInOvershoot = function (time, begin, change, duration, overshoot) {
        if (overshoot === void 0) { overshoot = 1.70158; }
        var val;
        val = (1 + overshoot) * Math.pow(time / duration, 3) - overshoot * Math.pow(time / duration, 2);
        return begin + change * val;
    };
    tbEase.easeOutOvershoot = function (time, begin, change, duration, overshoot) {
        var val = tbEase.easeInOvershoot(duration - time, 1, -1, duration, overshoot);
        return begin + change * val;
    };
    tbEase.easeInOutOvershoot = function (time, begin, change, duration, overshoot) {
        var val;
        if (time < duration / 2) {
            val = tbEase.easeInOvershoot(time, 0, 0.5, duration / 2, overshoot);
        }
        else {
            val = tbEase.easeInOvershoot(duration - time, 1, -0.5, duration / 2, overshoot);
        }
        return begin + change * val;
    };
    tbEase.easeOutInOvershoot = function (time, begin, change, duration, overshoot) {
        var val;
        if (time < duration / 2) {
            val = tbEase.easeInOvershoot(duration / 2 - time, 0.5, -0.5, duration / 2, overshoot);
        }
        else {
            val = tbEase.easeInOvershoot(time - duration / 2, 0.5, 0.5, duration / 2, overshoot);
        }
        return begin + change * val;
    };
    tbEase.easeInBounce = function (time, begin, change, duration, number, factor) {
        var bounces, i, w, width, height, val;
        // Correct the arguments
        if (number === undefined) {
            number = 4;
        }
        if (factor === undefined) {
            factor = 2;
        }
        else {
            factor = Math.sqrt(factor);
        }
        // Create the list of bounces
        bounces = [1];
        width = 1;
        for (i = 1; i < number; i += 1) {
            bounces.push(bounces[i - 1] * factor);
            width += bounces[i];
        }
        // Compute total size
        width -= bounces[number - 1] / 2; // We don't use the last half bounce
        height = Math.pow(bounces[number - 1], 2);
        time = time / duration * width;
        // Find the correct bounce
        w = 0;
        for (i = 0; i < number; i += 1) {
            if (time > bounces[i]) {
                time -= bounces[i];
            }
            else {
                w = bounces[i];
                break;
            }
        }
        // Now compute the value
        val = -4 * Math.pow(time - w / 2, 2) + w * w;
        return begin + change * val / height;
    };
    tbEase.easeOutBounce = function (time, begin, change, duration, number, factor) {
        var val = tbEase.easeInBounce(duration - time, 1, -1, duration, number, factor);
        return begin + change * val;
    };
    tbEase.easeInOutBounce = function (time, begin, change, duration, number, factor) {
        var val;
        if (time < duration / 2) {
            val = tbEase.easeInBounce(time, 0, 0.5, duration / 2, number, factor);
        }
        else {
            val = tbEase.easeInBounce(duration - time, 1, -0.5, duration / 2, number, factor);
        }
        return begin + change * val;
    };
    tbEase.easeOutInBounce = function (time, begin, change, duration, number, factor) {
        var val;
        if (time < duration / 2) {
            val = tbEase.easeInBounce(duration / 2 - time, 0.5, -0.5, duration / 2, number, factor);
        }
        else {
            val = tbEase.easeInBounce(time - duration / 2, 0.5, 0.5, duration / 2, number, factor);
        }
        return begin + change * val;
    };
    tbEase.easeCreateRepeat = function (func, repeat) {
        switch (repeat) {
            case tbEase.repeatConstant:
                return function (time, begin, change, duration, arg0, arg1, arg2) {
                    if (time < 0) {
                        return begin;
                    }
                    if (time > duration) {
                        return begin + change;
                    }
                    return func(time, begin, change, duration, arg0, arg1, arg2);
                };
            case tbEase.repeatRepeat:
                return function (time, begin, change, duration, arg0, arg1, arg2) {
                    return func(time - Math.floor(time / duration) * duration, begin, change, duration, arg0, arg1, arg2);
                };
            case tbEase.repeatMirror:
                return function (time, begin, change, duration, arg0, arg1, arg2) {
                    var val;
                    if (Math.floor(time / duration) % 2 === 0) {
                        val = func(time - Math.floor(time / duration) * duration, 0, 1, duration, arg0, arg1, arg2);
                    }
                    else {
                        val = func(duration - time + Math.floor(time / duration) * duration, 0, 1, duration, arg0, arg1, arg2);
                    }
                    return begin + change * val;
                };
            case tbEase.repeatFlip:
                return function (time, begin, change, duration, arg0, arg1, arg2) {
                    var val = func(time - Math.floor(time / duration) * duration, 0, 1, duration, arg0, arg1, arg2);
                    if (Math.floor(time / duration) % 2 !== 0) {
                        val = 1 - val;
                    }
                    return begin + change * val;
                };
            case tbEase.repeatContinuous:
                return function (time, begin, change, duration, arg0, arg1, arg2) {
                    var offset = Math.floor(time / duration), val = func(time - Math.floor(time / duration) * duration, 0, 1, duration, arg0, arg1, arg2);
                    return begin + change * (offset + val);
                };
            case tbEase.repeatContinuousMirror:
                return function (time, begin, change, duration, arg0, arg1, arg2) {
                    var val, offset = Math.floor(time / duration);
                    if (Math.floor(time / duration) % 2 === 0) {
                        val = func(time - Math.floor(time / duration) * duration, 0, 1, duration, arg0, arg1, arg2);
                    }
                    else {
                        val = func(duration - time + Math.floor(time / duration) * duration, 1, -1, duration, arg0, arg1, arg2);
                    }
                    return begin + change * (offset + val);
                };
            default:
                return function (time, begin, change, duration, arg0, arg1, arg2) {
                    return func(time, begin, change, duration, arg0, arg1, arg2);
                };
        }
    };
    //
    // Creating ease functions
    //
    tbEase._easeCreate = function (kind, coef5, coef4, coef3, coef2, coef1, normalize) {
        var tot;
        if (coef1 === undefined) {
            coef1 = 0;
        }
        if (coef2 === undefined) {
            coef2 = 0;
        }
        if (coef3 === undefined) {
            coef3 = 0;
        }
        if (coef4 === undefined) {
            coef4 = 0;
        }
        if (coef5 === undefined) {
            coef5 = 0;
        }
        if (normalize === undefined) {
            normalize = true;
        }
        tot = coef1 + coef2 + coef3 + coef4 + coef5;
        if (tot === 0) {
            tot = 1;
        }
        if (!normalize) {
            tot = 1;
        }
        switch (kind) {
            case 0: return function (time, begin, change, duration) {
                var t = time / duration, val = coef5 * Math.pow(t, 5) + coef4 * Math.pow(t, 4) + coef3 * Math.pow(t, 3) + coef2 * Math.pow(t, 2) + coef1 * t;
                return begin + change * val / tot;
            };
            case 1: return function (time, begin, change, duration) {
                var t = (duration - time) / duration, val = 1 - (coef5 * Math.pow(t, 5) + coef4 * Math.pow(t, 4) + coef3 * Math.pow(t, 3) + coef2 * Math.pow(t, 2) + coef1 * t);
                return begin + change * val / tot;
            };
            case 2: return function (time, begin, change, duration) {
                var t, val;
                if (time < duration / 2) {
                    t = time / (duration / 2);
                    val = 0.5 * (coef5 * Math.pow(t, 5) + coef4 * Math.pow(t, 4) + coef3 * Math.pow(t, 3) + coef2 * Math.pow(t, 2) + coef1 * t);
                }
                else {
                    t = (duration - time) / (duration / 2);
                    val = 1 - 0.5 * (coef5 * Math.pow(t, 5) + coef4 * Math.pow(t, 4) + coef3 * Math.pow(t, 3) + coef2 * Math.pow(t, 2) + coef1 * t);
                }
                return begin + change * val / tot;
            };
            case 3: return function (time, begin, change, duration) {
                var t, val;
                if (time < duration / 2) {
                    t = 1 - time / (duration / 2);
                    val = 0.5 - 0.5 * (coef5 * Math.pow(t, 5) + coef4 * Math.pow(t, 4) + coef3 * Math.pow(t, 3) + coef2 * Math.pow(t, 2) + coef1 * t);
                }
                else {
                    t = time / (duration / 2) - 1;
                    val = 0.5 + 0.5 * (coef5 * Math.pow(t, 5) + coef4 * Math.pow(t, 4) + coef3 * Math.pow(t, 3) + coef2 * Math.pow(t, 2) + coef1 * t);
                }
                return begin + change * val / tot;
            };
        }
    };
    tbEase.easeCreateIn = function (coef5, coef4, coef3, coef2, coef1, normalize) {
        return tbEase._easeCreate(0, coef5, coef4, coef3, coef2, coef1, normalize);
    };
    tbEase.easeCreateOut = function (coef5, coef4, coef3, coef2, coef1, normalize) {
        return tbEase._easeCreate(1, coef5, coef4, coef3, coef2, coef1, normalize);
    };
    tbEase.easeCreateInOut = function (coef5, coef4, coef3, coef2, coef1, normalize) {
        return tbEase._easeCreate(2, coef5, coef4, coef3, coef2, coef1, normalize);
    };
    tbEase.easeCreateOutIn = function (coef5, coef4, coef3, coef2, coef1, normalize) {
        return tbEase._easeCreate(3, coef5, coef4, coef3, coef2, coef1, normalize);
    };
    //
    // Combined ease functions
    //
    tbEase.easeCreateCombined = function (funcs, flips, lengths) {
        var j, ww = 0, hh, maxHeight = 1, startHeight = [0], startWidth = [0];
        // Make sure the flips array is correct
        if (flips === undefined) {
            flips = [];
        }
        while (flips.length < funcs.length) {
            flips.push(false);
        }
        // Make sure the lengths array is correct
        if (lengths === undefined) {
            lengths = [];
        }
        while (lengths.length < funcs.length) {
            lengths.push(1 / funcs.length);
        }
        for (j = 0; j < funcs.length; j += 1) {
            ww += lengths[j];
        }
        for (j = 0; j < funcs.length; j += 1) {
            lengths[j] /= ww;
        }
        // Compute the start width, height and maximal height
        for (j = 0; j < funcs.length; j += 1) {
            startWidth.push(startWidth[j] + lengths[j]);
            if (funcs[j] === tbEase.easeConstant) {
                hh = 0;
            }
            else if (flips[j]) {
                hh = -1;
            }
            else {
                hh = 1;
            }
            startHeight.push(startHeight[j] + hh);
            maxHeight = Math.max(maxHeight, startHeight[j + 1]);
        }
        return function (time, begin, change, duration, arg0, arg1, arg2) {
            var ind, i, val;
            // Compute the function index
            ind = funcs.length - 1;
            for (i = 0; i < funcs.length; i += 1) {
                if (time / duration <= startWidth[i + 1]) {
                    ind = i;
                    break;
                }
            }
            // Now compute the value
            val = funcs[ind](time / duration - startWidth[ind], 0, 1, lengths[ind], arg0, arg1, arg2);
            if (flips[ind]) {
                val = -val;
            }
            return begin + (startHeight[ind] + val) * change / maxHeight;
        };
    };
    //
    // Creating repeated ease functions
    //
    tbEase.repeatConstant = 0;
    tbEase.repeatRepeat = 1;
    tbEase.repeatMirror = 2;
    tbEase.repeatFlip = 3;
    tbEase.repeatContinuous = 4;
    tbEase.repeatContinuousMirror = 5;
    return tbEase;
}());
export { tbEase };
